import {environment} from "./environments/environment";

export const BASE_URL = environment.BASE_URL;